import { App } from "Core/App";

window._sdeApp = new App(); // initialize App
